module.exports = __webpack_public_path__ + "static/media/qr.5e8e97ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/img/qr.png
// module id = 519
// module chunks = 0